<template>
  <div class="file-uploader">
    <div v-if="!serverName" class="file-uploader--no-file">
      <input type="file" @change="onFileSelected" />
      <div class="file-uploader-form__error text-danger">
        <span v-if="uploadError">Error: {{ uploadError }}</span>
        <span v-if="!uploadError && !uploading">
          * Required
        </span>
      </div>
    </div>

    <div v-else class="file-uploader--has-file">
      <span class="file-uploader__localname">{{ localName }}</span>
      <button class="btn btn-danger" type="button" @click="clearFile">
        Clear File
      </button>
    </div>
  </div>
</template>

<script>
import api from "../api";
export default {
  name: "file-uploader",
  props: {
    localName: String,
    serverName: String,
  },
  data() {
    return {
      uploading: false,
      uploadError: false,
    };
  },
  methods: {
    async onFileSelected(e) {
      const [file] = e.target.files;
      const formData = new FormData();
      formData.append("file", file);
      this.uploading = true;
      this.uploadError = false;
      const response = await api
        .uploadDocument(formData)
        .catch(({ response }) => {
          const {
            data: { error = "" },
          } = response;
          this.uploadError = error;
        });
      if (response) {
        const {
          data: { filename = "", uploadedName = "" },
        } = response;
        this.$emit("change", { serverName: filename, localName: uploadedName });
      }
      this.uploading = false;
    },
    clearFile() {
      this.$emit("change", { serverName: "", localName: "" });
    },
  },
};
</script>

<style scoped>
.file-uploader__localname {
  margin-right: 1rem;
}
</style>
